import {
  Checkbox,
  Flex,
  FlexItem,
  FormElement,
  Select
} from 'mailup-web-components'
import {
  anagFiltersState,
  taskConditionsState
} from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

const ConditionAnagFilterFalse = () => {
  const [{ AnagFilterFalse, AnagFilterFalseId }, setTaskConditionsState] =
    useRecoilState(taskConditionsState)
  const { items } = useRecoilValue(anagFiltersState)
  const intl = useIntl()

  const onChangeConditionsAnagraphicFilterFalse = () => {
    setTaskConditionsState((prev) => ({
      ...prev,
      AnagFilterFalse: !prev.AnagFilterFalse,
      isDirty: true
    }))
  }

  const onChangeAnagFilterFalseId = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      AnagFilterFalseId: val,
      isDirty: true
    }))
  }

  return (
    <>
      <Flex alignItems='flex-start'>
        <FlexItem margin='10px 0 0 0'>
          <Checkbox
            checked={AnagFilterFalse}
            onChange={onChangeConditionsAnagraphicFilterFalse}
            label={intl.formatMessage(
              { id: 'Load.Task.ConditionsAnagraphicFilterFalse' },
              {
                strong: (str) => <strong>{str}</strong>
              }
            )}
            data-mu-test='checkBox-ConditionsAnagraphicFilterFalse'
          />
        </FlexItem>
        <Flex display='block' margin='0 8px' minWidth='300px'>
          <FormElement
            feedback={
              AnagFilterFalse && !AnagFilterFalseId
                ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                : null
            }
          >
            <Select
              value={AnagFilterFalseId}
              onChange={onChangeAnagFilterFalseId}
              searchable
              placeholder={intl.formatMessage({
                id: 'Load.Task.ConditionsAnagraphicFilterPlaceholder'
              })}
              disabled={!AnagFilterFalse}
              options={items}
              error={AnagFilterFalse && !AnagFilterFalseId ? 'danger' : null}
            />
          </FormElement>
        </Flex>
      </Flex>
    </>
  )
}

export default ConditionAnagFilterFalse
